import { base } from "./base";
import { errorToastHook } from "./hooks/errorToast";
import { loaderEndHook, loaderErrorHook, loaderStartHook } from "./hooks/loader";
import { workflowAuthHook } from "./hooks/auth";
import { workflowTokenRefreshHook } from "./hooks/tokenRefresh";

// Workflow-authenticated instance — loader + workflow token + workflow 403 refresh
export const httpWorkflowAuth2 = base.extend({
  hooks: {
    afterResponse: [loaderEndHook, workflowTokenRefreshHook],
    beforeError: [loaderErrorHook, errorToastHook],
    beforeRequest: [loaderStartHook, workflowAuthHook],
  },
});
